import React, { useRef, useState } from 'react';
// import { reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { useSelector } from 'react-redux';
import { getJsonEditor, getSessionId } from '../../../store';
import { getDndComponents } from '../additionalNodes';

interface dndBarNodeProps {
  componentType: string;
  label: string;
  output?: boolean;
}

export const DndBarNode = ({ componentType, label, output }: dndBarNodeProps) => {
  let cn = output ? 'dndnode output' : 'dndnode';
  
  const onDragStart = (event: React.DragEvent<HTMLDivElement>, nodeType: string) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };
  return (
    <div className={cn} onDragStart={(event) => onDragStart(event, componentType)} draggable>
      {label}
    </div>
  );
};

function DnDBarComponent({ tabId, setShow }: { tabId: string; setShow: any; setDeployState: any }) {
  const editorState = useSelector(getJsonEditor);
  const sessionId = useSelector(getSessionId);

  return (
    <aside>
      <div className="description">You can drag these nodes to the pane on the left.</div>
      <div className="dndnodeWrapper">
        {(!editorState.flowcharts[tabId] || editorState.flowcharts[tabId].flowchartType === 'UserJourney') && (
          <DndBarNode componentType="signIn" label="SignUp / SignIn" />
        )}
        {editorState.flowcharts[tabId] && editorState.flowcharts[tabId].flowchartType === 'userInfoEndpoint' && (
          <DndBarNode componentType="authorizeToken" label="Authorize Token" />
        )}
        <DndBarNode componentType="aadRead" label="AAD Read" />
        <DndBarNode componentType="aadUpdate" label="AAD Update" />
        <DndBarNode componentType="aadCreate" label="AAD Create" />
        <DndBarNode componentType="restAPI" label="REST API" />
        <DndBarNode componentType="setClaims" label="Set Claims" />
        {editorState.flowcharts[tabId] && editorState.flowcharts[tabId].flowchartType === 'formSubmitAction' && (
          <>
            <DndBarNode componentType="usernamePasswordValidation" label="Username Password Validation" />
            <DndBarNode componentType="validationError" label="Validation Error" />
          </>
        )}
        <DndBarNode componentType="conditionals" label="Conditionals" output />
        <DndBarNode componentType="appInsights" label="Application Insights" />
        {editorState.flowcharts[tabId] && editorState.flowcharts[tabId].flowchartType === 'UserJourney' && (
          <>
            <DndBarNode componentType="userInputPage" label="User Input Page" />
            <DndBarNode componentType="mfa" label="MFA" />
            <DndBarNode componentType="sessionExists" label="SSO Session Exists" output />
            {/*<DndBarNode componentType="validateMagicLink" label="Validate Magic Link"/>*/}
            <DndBarNode componentType="webAuthnRegistration" label="WebAuthn Registration" />
            <DndBarNode componentType="webAuthnAuthentication" label="WebAuthn Authentication" />
            <DndBarNode componentType="webAuthnAvailability" label="WebAuthn Availability" />
            <DndBarNode componentType="webAuthnCredentialsExist" label="WebAuthn Credentials Exist" />
            <DndBarNode componentType="conditionalAccessEvaluation" label="Conditional Access Eval." />
            <DndBarNode componentType="conditionalAccessRemediation" label="Conditional Access Remed." />
            <DndBarNode componentType="oidcIdP" label="OIDC IdP Authentication" />
            <DndBarNode componentType="samlIdP" label="SAML IdP Authentication" />
            <DndBarNode componentType="errorPage" label="Error Page" />
            <DndBarNode componentType="tokenIssuer" label="Token Issuer" />
            {getDndComponents()}
          </>
        )}
        {editorState.flowcharts[tabId] && editorState.flowcharts[tabId].flowchartType === 'userInfoEndpoint' && (
          <>
            <DndBarNode componentType="userInfoIssuer" label="User Info Issuer" />
          </>
        )}
        {editorState.flowcharts[tabId] &&
          editorState.flowcharts[tabId].flowchartType === 'emailVerificationSendAction' && (
            <>
              <DndBarNode componentType="sendEmailOTP" label="Send Email OTP" />
            </>
          )}
      </div>

      <div style={{ marginTop: '20px' }}></div>
    </aside>
  );
}

// export default withAITracking(reactPlugin, DnDBarComponent);
export default DnDBarComponent;
